module.exports = __webpack_public_path__ + "img/logo_sidebar.58097bbd.png";